export default __webpack_public_path__ + "static/media/veeam.adf9edbb.png";